import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { ReactComponent as Close } from "assets/icons/CloseFilter.svg";
import deceasedPhoto from "assets/icons/speaker.svg";
import { useFormik } from "formik";
import { useDisableEnterKey } from "hook/useDisableEnterKey";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCreateCampaignDialog } from "services/api/communication";
import { CreatedCampaignDone } from "./CreatedCampaignDone/CreatedCampaignDone";
import { MyTemplate } from "./MyTemplate/MyTemplate";
import { NewCampaign } from "./NewCampaign";
import { NewTemplate } from "./NewTemplate/NewTemplate";
import { TextMessege } from "./TextMessege/TextMessege";
import { CloseIcon, Content, Image, StepperWrapper, Wrapper } from "./Theme";
import { toEtPickerDate } from "helper/dateFormat";

export const CreateCampaign = ({ setToggle, onClose }) => {
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [cardName, setCardName] = useState("");
  const { selectedAudienceRows } = useSelector((state) => state.communication);
  const { selectedTemplate, campaignEditData } = useSelector((state) => state.communication)


  useDisableEnterKey(true);

  const countTotalCampaign = selectedAudienceRows.map((val) =>
    cardName === "TextMessage" || cardName === "WhatsApp" ? val.numberOfPhones : val.numberOfEmails
  );
  const sum = countTotalCampaign?.reduce(
    (accumulator, currentValue) => accumulator + currentValue,
    0
  );

  const campaignDoneDetails =
    cardName === "TextMessage" || cardName === "WhatsApp"
      ? [`Campaign has total ${sum} people`]
      : cardName === "PushNotification"
      ? []
      : [
        `Campaign has total ${sum} people`,
        `"${Object.keys(selectedTemplate).length > 0
          ? selectedTemplate?.title
          : campaignEditData?.template?.title
        }" has been selected`,
      ];
  const cardContent = useSelector((state) => state.communication.cardContent);
  const dispatch = useDispatch()
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      campainName: campaignEditData?.campaignName,
      scheduledCampaign: !!campaignEditData?.isScheduled,
      emailDate: toEtPickerDate(campaignEditData?.scheduled?.date) || "",
      subject: null,
    },
    validationSchema: "",
  });

  const handleReset = () => {
    formik.resetForm({
      values: {
        campainName: "",
        scheduledCampaign: false,
        emailDate: "",
        subject: null,
      },
    });
  };
  const handleNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };
  const handleClose = () => {
    setOpen(false);
    setActiveStep(null); // Reset to the first step
    setToggle("Campaigns")
  };
  const renderContentCards = () => {
    switch (cardContent) {
      case "New template":
        return (
          <NewTemplate
            onNext={handleNext}
            formik={formik}
            cardContent={cardContent}
            activeStep={activeStep}
            onBack={handleBack}
            setActiveStep={setActiveStep}
            setCardName={setCardName}

          />
        );
      case "My template":
        return (
          <MyTemplate
            onNext={handleNext}
            onBack={handleBack}
            cardContent={cardContent}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            handleResetFormik={handleReset}
          />
        );
      case "Text message":
        return (
          <TextMessege
            onNext={handleNext}
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
          />
        );
      case "Push notification":
        return (
          <TextMessege
            onNext={handleNext}
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            campaignType="push"
          />
        );
      case "WhatsApp":
        return (
          <TextMessege
            onNext={handleNext}
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            setCardName={setCardName}
            campaignType="whatsapp"
          />
        );
      case "Done":
        return (
          <CreatedCampaignDone
            onBack={handleBack}
            onClose={handleClose}
            formik={formik}
            text={`${formik.values?.campainName} Successfully Created`}
            details={campaignDoneDetails}
            setCampaignModal={() => dispatch(setCreateCampaignDialog(false))}
            cardName={cardName}
            setToggle={setToggle}
          />
        );
      default:
        return (
          <NewCampaign
            formik={formik}
            handleResetFormik={handleReset}
          />
        );
    }
  }

  return (
    <Wrapper>
      <CloseIcon onClick={onClose}>
        <Close />
      </CloseIcon>
      <Image>
        <img src={deceasedPhoto} alt="deceased" />
      </Image>
      <Content>
        {cardContent !== "Done" && (
          <StepperWrapper>
            <div
              className="class__steps"
              style={{ width: "39rem", marginBottom: "20px" }}
            >
              <Stepper activeStep={activeStep}>
                <Step className="step">
                  <StepLabel className="step-label">Create Campaign</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Edit</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Send</StepLabel>
                </Step>
              </Stepper>
            </div>
          </StepperWrapper>
        )}

        <div className="filter-container">
          {renderContentCards()}
        </div>
      </Content>
    </Wrapper>
  );
};
